import { Button } from '@osmosis/tailwind-ui/components/Button';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faExpand } from '@fortawesome/pro-regular-svg-icons/faExpand';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { bg1 } from '@osmosis/tailwind-ui/styles/background';
import { faCompress } from '@fortawesome/pro-regular-svg-icons/faCompress';
import { FormattedMessage, useIntl } from 'react-intl';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';

interface NotesPageButtonsBlockProps {
  isFullscreen: boolean;
  isDownloading: boolean;
  toggleFullscreen: () => void;
  handleDownload: () => void;
}

/**
 * Renders the buttons for toggling fullscreen and downloading notes on the notes page.
 * @param {NotesPageButtonsBlockProps} props - The props for the component.
 */
const NotesPageButtonsBlock = ({
  isFullscreen,
  isDownloading,
  toggleFullscreen,
  handleDownload,
}: NotesPageButtonsBlockProps) => {
  const intl = useIntl();

  const fullScreenLabel = intl.formatMessage({
    id: 'notesPage.buttons.toggleFullscreen',
    defaultMessage: 'Toggle Full Screen',
  });
  const downloadLabel = intl.formatMessage({
    id: 'notesPage.buttons.downloadNote',
    defaultMessage: 'Download note',
  });

  return (
    <Box className="flex flex-col lg:flex-row">
      <Button
        cn="w-[175px] mr-4 mb-4"
        data-testid="notesPage.buttons.fullscreen"
        aria-label={fullScreenLabel}
        onClick={toggleFullscreen}
      >
        {isFullscreen ? (
          <Icon icon={faCompress} className="mr-2" />
        ) : (
          <Icon icon={faExpand} className="mr-2" />
        )}
        {isFullscreen ? (
          <FormattedMessage
            id="notesPage.buttons.exitfullscreen"
            defaultMessage="Exit Full Screen"
          />
        ) : (
          <FormattedMessage
            id="notesPage.buttons.fullscreen"
            defaultMessage="Full Screen"
          />
        )}
      </Button>
      <Button
        cn={`w-[175px] ${bg1} mb-4`}
        data-testid="notesPage.buttons.download"
        variant="outline"
        color="blue"
        aria-label={downloadLabel}
        isLoading={isDownloading}
        onClick={handleDownload}
      >
        <Icon icon={faDownload} className="mr-2" />
        <FormattedMessage
          id="notesPage.buttons.download"
          defaultMessage="Download"
        />
      </Button>
    </Box>
  );
};

export default NotesPageButtonsBlock;
